import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from './icon.js';
import { cn } from '../lib/cn.js';
/**
 * An empty screen is a first impression, not an error.
 *
 * Every empty state answers the same three questions in the same shape: what
 * lives here, why is it empty, and what do I do about it. A blank white card
 * answers none of them, and a new user meets more empty states in their first
 * hour than full ones.
 */
export function EmptyState({ icon, title, body, action, className, }) {
    return (_jsxs("div", { className: cn('flex flex-col items-center rounded-[var(--radius-surface)] border border-dashed', 'border-border-strong bg-surface px-6 py-12 text-center', className), children: [_jsx("span", { className: "flex size-12 items-center justify-center rounded-full bg-brand-50", children: _jsx(Icon, { name: icon, className: "size-6 text-brand-600" }) }), _jsx("p", { className: "mt-4 text-base font-semibold text-content", children: title }), _jsx("p", { className: "mx-auto mt-1 max-w-sm text-sm leading-relaxed text-content-muted", children: body }), action === undefined ? null : _jsx("div", { className: "mt-5", children: action })] }));
}
//# sourceMappingURL=empty-state.js.map